import React from 'react';
import createSvgIcon from '../../../shared/utils/create-svg-icon';
import { ReactComponent as Icon } from '../../../assets/icon-table.svg';

export const TableIcon = createSvgIcon(<Icon />, 'TableIcon');
